<template>
  <div class="select-none">
    <div>
      <slot name="selection" />
    </div>
    <div
      :class="{ 'bg-zuno-turquoise/20': isOpen }"
      class="ml-3 flex w-full cursor-pointer justify-between border border-gray-300 bg-white px-6 py-4 pl-8"
      :aria-expanded="isOpen"
      :aria-controls="`collapse${uid}`"
    >
      <div
        class="flex"
        @click="toggleAccordion()"
      >
        <slot name="title" />
      </div>
      <div class="flex grow">
        <slot name="labels" />
      </div>
      <div>
        <slot name="actions" />
      </div>
      <svg
        class="w-3 transform transition-all duration-200"
        :class="{ 'rotate-180': isOpen, 'rotate-0': !isOpen }"
        fill="none"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 10"
        aria-hidden="true"
        @click="toggleAccordion()"
      >
        <path
          d="M15 1.2l-7 7-7-7"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div
      v-show="isOpen"
      :id="`collapse${uid}`"
      class="ml-3 w-full border border-gray-300 bg-white px-6 py-4"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SourceTypesAccordion',

  data() {
    return {
      isOpen: false,
      uid: null,
    }
  },

  mounted() {
    this.uid = this.$.uid
  },

  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>
